export default __webpack_public_path__ + "static/media/ListIconHighlight.2cfd8477.svg";